<template>
  <nav :class="$style['GroupWrap']">
    <section
      :class="[
        $style['mds-section'],
        this.$style['mds-section--collapsible'],
        classObject,
      ]"
    >
      <div
        :class="[
          $style['mds-section__header-container'],
          $style[`mds-section--level-5`],
          $style['mds-section--font-bold'],
        ]"
        :aria-expanded="open"
        :aria-controls="expandedId"
        role="button"
        @click="open = !open"
      >
        <mds-icon
          name="triangle-fill-right"
          :class="$style['mds-section__toggle']"
          size="small"
        />

        <h2
          :class="[
            $style['mds-section__title'],
            $style['mds-section--font-bold'],
          ]"
        >
          {{ mainHeading }}
        </h2>
      </div>
      <div v-if="open" :class="$style['mds-section__content']" :id="expandedId">
        <mds-table class="grouped-row-example">
          <mds-thead>
            <mds-th
              v-for="(header, index) in headers"
              :key="index"
              :right-aligned="header.align === 'right'"
              :style="header.style"
            >
              <div
                v-if="header.text != ''"
                :style="
                  header.switchRequied
                    ? 'margin-bottom: 10px'
                    : 'padding-left:20px'
                "
              >
                <span
                  :style="'background-color:' + header.colour + ';'"
                  :class="$style['header-legend-box']"
                >
                </span>
                {{ header.text }}
              </div>

              <mds-switch
                :v-model="header.fieldName"
                v-if="header.switchRequied && header.text != ''"
                :value="header.fieldName"
                hidden-label
                >.
              </mds-switch>
              <span
                :class="$style['HeadingIcon']"
                v-if="header.switchRequied && false"
              >
                <mds-icon
                  name="undo"
                  :class="$style['mds-section__toggle']"
                  size="small"
                />
                <mds-icon
                  name="remove"
                  :class="$style['mds-section__toggle']"
                  size="small"
                  @click.native="DeleteComparison(header)"
                />
              </span>
            </mds-th>
          </mds-thead>
          <mds-tbody>
            <template
              v-for="(row, index) in groupedRows.filter((x) => x.visible)"
            >
              <mds-tr
                type="expandable"
                :expanded="row.expanded"
                :aria-controls="index + 1"
                total-row
                @click.native="toggleGroupedRow(index)"
                @keyup.enter.native="toggleGroupedRow(index)"
              >
                <mds-td
                  v-for="(header, i) in headers"
                  :key="i"
                  :right-aligned="header.align === 'right'"
                  :style="header.style"
                >
                  {{ row[header.fieldName] }}
                </mds-td>
              </mds-tr>
              <mds-tr type="container" :id="index + 1" v-if="row.expanded">
                <mds-td :colspan="headers.length">
                  <mds-table>
                    <mds-tbody>
                      <mds-tr
                        v-for="(header, i) in row.columns"
                        :key="i"
                        v-if="
                          row.columns[i].visible ||
                          row.columns[i].visible == undefined
                        "
                      >
                        <mds-td
                          :class="$style['alignFirstElm']"
                          :style="header.style"
                        >
                          <div v-html="row.columns[i].text"></div>
                        </mds-td>
                        <mds-td
                          v-for="(rw, index) in headers.filter(
                            (x) => x.switchRequied
                          )"
                          :key="index"
                          :right-aligned="header.align === 'right'"
                        >
                          <template
                            v-if="
                              header != undefined && header.type == 'DataList'
                            "
                          >
                            <adl-data-list
                              v-if="
                                rowsdata[row.groupid][rw.fieldName][header.name]
                                  .listdata.length > 0
                              "
                              :headingtext="
                                rowsdata[row.groupid][rw.fieldName][header.name]
                                  .headingtext
                              "
                              :listdata="
                                rowsdata[row.groupid][rw.fieldName][header.name]
                                  .listdata
                              "
                              :editbuttonvisible="false"
                              :ToggleRequired="false"
                            ></adl-data-list>
                          </template>
                          <template
                            v-else-if="
                              header != undefined && header.type == 'multiline'
                            "
                          >
                            <div
                              v-for="(row, index) in rowsdata[row.groupid][
                                rw.fieldName
                              ][header.name]"
                              :key="index"
                            >
                              <br v-if="index == 0" />
                              {{ row.innerText }}
                              <br />
                            </div>
                            <!-- {{
                              rowsdata[row.groupid][rw.fieldName][header.name]
                            }} -->
                          </template>
                          <template
                            v-else-if="
                              header != undefined &&
                              header.type == 'multilinewithheader'
                            "
                          >
                            <br />
                            <span
                              v-for="(row, index) in rowsdata[row.groupid][
                                rw.fieldName
                              ][header.name]"
                              :key="index"
                            >
                              <span :class="$style['dataListLabel']">
                                {{ row.heading }}</span
                              >
                              <br />
                              {{ row.innerText }}
                              <br />
                            </span>
                            <!-- {{
                               rowsdata[row.groupid][rw.fieldName][header.name]
                             }} -->
                          </template>
                          <template v-else>
                            {{
                              rowsdata[row.groupid][rw.fieldName][header.name]
                            }}
                          </template>
                        </mds-td>
                      </mds-tr>
                    </mds-tbody>
                  </mds-table>
                </mds-td>
              </mds-tr>
            </template>
          </mds-tbody>
        </mds-table>
      </div>
    </section>
  </nav>
</template>

<script>
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table";
import AdlDataList from "../DataList/DataList.vue";
import MdsSwitch from "@mds/switch";
import MdsIcon from "@mds/icon";

export default {
  name: "AdlCompareTable",
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    AdlDataList,
    MdsSwitch,
    MdsIcon,
  },
  props: {
    headers: Array,
    rowsdata: Object,
    groupedRows: Array,
    open: {
      type: Boolean,
      default: true,
    },
    mainHeading: String,
  },
  computed: {
    classObject() {
      const obj = {};
      obj[this.$style["mds-section--expanded"]] = this.open;
      return obj;
    },
    expandedId() {
      const randomId = Math.random() * Math.floor(1000000);
      return `mds-section-${Math.round(randomId)}`;
    },
  },
  methods: {
    DeleteComparison(d) {
      this.headers = this.headers.filter((e) => e.fieldName !== d.fieldName);
      this.$emit("OnDelete", d);
    },
    toggleGroupedRow(index) {
      const status = this.groupedRows[index].expanded
        ? !this.groupedRows[index].expanded
        : true;
      this.$set(this.groupedRows[index], "expanded", status);
    },
  },
};
</script>
<style lang="scss" module scoped>
@import "./section.scss";

// .header-legend-box {

//   width: 10px;
//   height: 10px;
//   display: inline-block;
//   background-color: red;
// }

table thead th:not(:first-child) .header-legend-box {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: red;
}

.GroupWrap {
  border: $mds-border-separator-on-light;
  padding: $mds-space-3-x $mds-space-2-x;
  border-radius: $mds-space-1-x;
  background-color: $mds-background-color-white;
  margin-top: $mds-space-3-x;
}

table thead th:hover .HeadingIcon {
  opacity: 1;
}

.HeadingIcon {
  position: absolute;
  top: 0;
  right: $mds-space-1-x;
  opacity: 0;
  cursor: pointer;
}
.dataListLabel {
  font-weight: bold;
  color: #1e1e1e !important;
}

.GroupWrap {
  .alignFirstElm {
    padding-left: 20px;
  }
}
</style>
